export default function getContributorNamesByRole(contributors, role) {
	return (
		contributors
			?.filter((contributor) => contributor.role === role)
			.map(({ firstName, lastName }) => `${firstName} ${lastName}`) || []
	);
}
